import { MouseEvent, KeyboardEvent } from "react";

import { trns } from "../helper.js";
import { clsx } from "clsx";
import { Button } from "ui-components";

type Props = {
  disabled?: boolean;
  isStart: boolean;
  isFinal: boolean;
  onSubmit: (e: KeyboardEvent | MouseEvent<HTMLButtonElement>) => Promise<void>;
};

const NextButton = ({ disabled, isStart, isFinal, onSubmit }: Props) => (
  <>
    {isFinal ? (
      <Button
        type="button"
        disabled={disabled}
        onClick={onSubmit}
        className={clsx({ "btn success btn-next": true, "btn-submit": isFinal })}
      >
        {trns("IDS_LOGINBOX_SUBMIT_THIS_INFO", "Register")}
      </Button>
    ) : (
      <Button
        type="button"
        disabled={disabled}
        onClick={onSubmit}
        className={clsx({ "btn primary btn-next": true, "btn-full-width": isStart })}
      >
        {trns("IDS_LOGINBOX_NEXT", "Next")}
      </Button>
    )}
  </>
);

export default NextButton;
